"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UserMenu", {
  enumerable: true,
  get: function get() {
    return _UserMenu.UserMenu;
  }
});
var _UserMenu = require("./UserMenu");